import { Observable } from 'rxjs';
import { LoginRequestDto } from '../dtos/login.request.dto';
import { LoginResponseDto } from '../dtos/login.response.dto';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UserPersonResponseDto } from '@domain/user-person/dtos/user-person.response.dto';
import { RecoveryPasswordRequestDto } from '../dtos/recovery-password.request.dto';
import { TimerRequestDto } from '../dtos/timer.request.dto';
import { TimerResponseDto } from '../dtos/timer.response.dto';
import { VerifyMailRequestDto } from '../dtos/verify-mail.request.dto';
import { ResetPasswordRequestDto } from '../dtos/reset-password.request.dto';
import { VerifyMailResponseDto } from '../dtos/verify-mail.response.dto';
import { GetCompanyRequestDto } from '../dtos/get-company.request.dto';
import { GetCompanyResponseDto } from '../dtos/get-company.response.dto';
import { ShowHoldingRequestDto } from '../dtos/show-holding.request.dto';
import { OrganizationHoldingResponseDto } from '@domain/organization-holding/dtos/organization-holding.response.dto';

export abstract class AuthRepository {
  abstract login(
    request: LoginRequestDto,
  ): Observable<ApiResponse<LoginResponseDto>>;

  abstract recoveryPassword(
    request: RecoveryPasswordRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>>;

  abstract resetPassword(
    request: ResetPasswordRequestDto,
  ): Observable<ApiResponse<object>>;

  abstract timer(
    request: TimerRequestDto,
  ): Observable<ApiResponse<TimerResponseDto>>;

  abstract verifyMail(
    request: VerifyMailRequestDto,
  ): Observable<ApiResponse<VerifyMailResponseDto>>;

  abstract getCompany(
    request: GetCompanyRequestDto,
  ): Observable<ApiResponse<GetCompanyResponseDto>>;

  abstract showHolding(
    request: ShowHoldingRequestDto,
  ): Observable<ApiResponse<OrganizationHoldingResponseDto>>;
}
